import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useQuery } from "react-query";
import { useSetState } from "react-use";
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { Link, useLocation, useParams } from "react-router-dom";
// primereact
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
// components
import CardEnterprise from "../../../components/cards/CardEnterprise";
// services
import { getCheckConfigSimulator } from "../../../services/Enterprise/getCheckConfigSImulator";
//context
import { useAppContext } from "../../../context/AppContext";
import { useContextSimulator } from "./Simulator/SimulatorContext";
//utils
import { getUserId } from "../../../utils/auth";
import { logGroup, translatedButtons } from "../../../utils/joyHelpers";
import usePermission from "../../../hooks/usePermission";

export default function Enterprise() {


  usePermission("15"); //Visualizar Gestão de Vendas

  const { id } = useParams(); //get id
  const { state } = useLocation();
  const userId = getUserId();

  const { permissions } = useAppContext();
  const [isLoading, setIsLoading] = useState(true);

  const [{ run, stepIndex, steps }, setState] = useSetState({
    run: false,
    stepIndex: 0,
    steps: [],
  });

  const items = [
    {
      template: () => (
        <Link to={`/salesManagement`} className="p-breadcrumb-link">
          {state ? state.name : "Empreendimento"}
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterprise/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Gestão de Vendas
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { clearStates, setHasMap } = useContextSimulator();

  const { data: allTrue, isLoading: isAllTrueLoading } = useQuery({
    queryKey: [`checkConfig-${id}`],
    queryFn: () => getCheckConfigSimulator(id),
    retry: false,
  });

  useEffect(() => {
    if (allTrue && allTrue.map_map) {
      setHasMap(true);
    }
    !isAllTrueLoading && setIsLoading(false);
    clearStates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allTrue]);

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    // console.log(data);
    if (([STATUS.FINISHED, STATUS.SKIPPED]).includes(status)) {
      // Need to set our running state to false, so we can restart if we click start again.
      Cookies.set(`hasSeenEnterpriseTour_${userId}`, 'true');
      setState({ run: false, stepIndex: 0 });
    } else if (([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND]).includes(type)) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

      setState({
        stepIndex: nextStepIndex,
      });
    }

    logGroup(type === EVENTS.TOUR_STATUS ? `${type}:${status}` : type, data);
  };

  useEffect(() => {
    const hasSeenTour = Cookies.get(`hasSeenEnterpriseTour_${userId}`);

    if (!isLoading && !hasSeenTour) {
      setState({
        run: true,
        steps: [
          {
            content: <>
              <h2>Negociações</h2>
              <p className="mb-0">Aqui você encontra as suas Simulações, Propostas e Vendas.</p>
            </>,
            target: '.negotiations',
            disableBeacon: true
          },
          {
            content: <>
              <h2>Simulador</h2>
              <p className="mb-0">Aqui você simula vendas em diversas condições, e caso queira pode enviar uma simulação ou proposta para análise.</p>
            </>,
            target: '.simulator',
            disableBeacon: true
          },
          {
            content: <>
              <h2>Espelho de Vendas</h2>
              <p className="mb-0">Consulte suas unidades e entenda o que está Vendido, Reservado e Disponível.</p>
            </>,
            target: '.salesMirror',
            disableBeacon: true
          },
          {
            content: <>
              <h2>Documentos</h2>
              <p className="mb-0">Consulte os documentos do empreendimento, visualize-os e faça download se for preciso.</p>
            </>,
            target: '.documents',
            disableBeacon: true
          },
        ]
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading])

  return (
    <>
      <Joyride
        callback={handleJoyrideCallback}
        continuous
        run={run}
        scrollToFirstStep
        showProgress
        showSkipButton
        stepIndex={stepIndex}
        locale={translatedButtons}
        steps={steps}
        styles={{
          options: {
            primaryColor: '#00b9a7',
            buttonNext: {
              color: '#FFFFFF',
            },
            buttonPrev: {
              color: '#FFFFFF',
            },
          },
        }}
      />
      <div>
        <BreadCrumb
          home={home}
          model={items}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      {isLoading && (
        <>
          <div className="row d-flex">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="col-xl-3 col-sm-6 pb-3">
                <div
                  className="widget widget-stats bg-gray-400 mb-7px"
                  style={{ height: "100%" }}
                >
                  <div className="stats-icon stats-icon-lg">
                    <Skeleton width="80%" height="100px"></Skeleton>
                  </div>
                  <div className="stats-content">
                    <div className="stats-number">
                      <Skeleton width="50%" height="50px"></Skeleton>
                    </div>
                    <div className="stats-desc pt-3">
                      <div className="stats-link">
                        <Skeleton width="40%" height="10px"></Skeleton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {!isLoading && (
        <div className="row">
          {permissions && permissions.includes("17") && ( //Visualizar Dashboard do Empreendimento
            <CardEnterprise
              title="Dashboard"
              link={`/enterprise/dashboard/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa fa-globe fa-fw"></i>}
              color={"widget widget-stats bg-teal mb-7px"}
            />
          )}
          {permissions && permissions.includes("18") && ( //Visualizar Negociacões
            <CardEnterprise
              id="negotiations"
              className="negotiations"
              title="Negociações"
              link={`/negotiations/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-file-lines"></i>}
              color={"widget widget-stats bg-blue mb-7px"}
            />
          )}

          {permissions && permissions.includes("87") && ( //Realizar Simulação
            <CardEnterprise
              id="simulator"
              className="simulator"
              title="Simulador"
              // onClick={handleState}
              link={`/enterprise/simulator/`}
              params={{
                empId: id,
                name: state ? state.name : "Empreendimento",
                fromCard: true,
              }}
              icon={<i className="fa-solid fa-comments-dollar"></i>}
              color={"widget widget-stats bg-purple mb-7px"}
            />
          )}
          {permissions && permissions.includes("19") && ( //Visualizar Espelho de Vendas
            <CardEnterprise
              id="salesMirror"
              className="salesMirror"
              title="Espelho de Vendas"
              link={`/salesMirror/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-file-invoice-dollar"></i>}
              color={"widget widget-stats bg-pink mb-7px"}
            />
          )}
          {allTrue && allTrue.map_map && permissions && permissions.includes("20") && ( //Visualizar Mapa
            <CardEnterprise
              title="Mapa"
              className="map"
              link={`/enterprise/map/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-map-location-dot"></i>}
              color={"widget widget-stats bg-green mb-7px"}
            />
          )}
          {permissions?.includes("21") && ( //Visualizar Mapa do Googe
            <CardEnterprise
              id="mapGoogle"
              className="mapGoogle"
              title="Mapa do Google"
              link={`/enterprise/googleMaps/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-brands fa-google"></i>}
              color={"widget widget-stats bg-red mb-7px"}
            />
          )}
          {permissions && permissions.includes("22") && ( //Visualizar Documentos via Empreendimento
            <CardEnterprise
              id="documents"
              className="documents"
              title="Documentos"
              link={`/enterprise/documents/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-sharp fa-solid fa-folder-open"></i>}
              color={"widget widget-stats bg-warning mb-7px"}
            />
          )}
          {permissions && permissions.includes("23") && ( //Visualizar Reajuste de Contrato
            <CardEnterprise
              id="contractReadjustment"
              className="contractReadjustment"
              title="Reajustar Contrato"
              link={`/enterprise/contractAdjustment/${id}`}
              params={{ name: state ? state.name : "Empreendimento" }}
              icon={<i className="fa-solid fa-file"></i>}
              color={"widget widget-stats bg-gray mb-7px"}
            />
          )}
        </div>
      )}
    </>
  );
}
